import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getQuarantinedProductsToDestroy } from "../../../redux/api/inventory.api";
import { clearDepositStocks } from "../../../redux/reducer/inventory.reducer";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getQuarantineProductRecordsTableData,
  quarantineProductRecordsTableHeader,
} from "./tableConfig/quaratineProductRecordsTableConfig";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

function QuarantineProductRecords() {
  const dispatch = useAppDispatch();
  const {
    inventory: {
      quarantinedProductsToDestroy: {
        data: { data: produseCarantinate, total: nrTotalProduse },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    inventory: state.inventory,
  }));

  const providers = useMemo(() => {
    const allProvidersRaw = produseCarantinate.flatMap(
      (item) => item.furnizori ?? [],
    );

    return [...new Map(allProvidersRaw.map((p) => [p.id, p])).values()];
  }, [produseCarantinate]);

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        getQuarantinedProductsToDestroy({
          page: 1,
          per_page: 10000,
          reason: action.tableSearch.reason,
          provider: action.tableSearch.provider,
        }),
      );
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearDepositStocks());
    };
  }, [dispatch]);

  return (
    <TableWidget
      tableTitle={"Evidenta produselor aflate in carantina"}
      tableHeaderData={quarantineProductRecordsTableHeader(providers)}
      tableItemsData={getQuarantineProductRecordsTableData(produseCarantinate)}
      handleTableActions={handleTableActions}
      totalItems={nrTotalProduse}
      tableLoading={isLoading}
      withGlobalFilter={false}
      withTablePagination={false}
    />
  );
}

export default QuarantineProductRecords;
